module.exports = "/_next/static/images/27a8e8a80d90a70e9b1e9e793db69fd5-group-man-building@0.5x.jpg.webp";